/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CloseDeliveries200Response,
  CloseDeliveriesRequest,
  OpenDeliveriesRequest,
} from '../models/index';
import {
    CloseDeliveries200ResponseFromJSON,
    CloseDeliveries200ResponseToJSON,
    CloseDeliveriesRequestFromJSON,
    CloseDeliveriesRequestToJSON,
    OpenDeliveriesRequestFromJSON,
    OpenDeliveriesRequestToJSON,
} from '../models/index';

export interface CloseDeliveriesOperationRequest {
    closeDeliveriesRequest: CloseDeliveriesRequest;
}

export interface OpenDeliveriesOperationRequest {
    openDeliveriesRequest: OpenDeliveriesRequest;
}

/**
 * 
 */
export class DeliveriesApi extends runtime.BaseAPI {

    /**
     */
    async closeDeliveriesRaw(requestParameters: CloseDeliveriesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CloseDeliveries200Response>> {
        if (requestParameters['closeDeliveriesRequest'] == null) {
            throw new runtime.RequiredError(
                'closeDeliveriesRequest',
                'Required parameter "closeDeliveriesRequest" was null or undefined when calling closeDeliveries().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/deliveries/close`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CloseDeliveriesRequestToJSON(requestParameters['closeDeliveriesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CloseDeliveries200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async closeDeliveries(requestParameters: CloseDeliveriesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CloseDeliveries200Response> {
        const response = await this.closeDeliveriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async openDeliveriesRaw(requestParameters: OpenDeliveriesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CloseDeliveries200Response>> {
        if (requestParameters['openDeliveriesRequest'] == null) {
            throw new runtime.RequiredError(
                'openDeliveriesRequest',
                'Required parameter "openDeliveriesRequest" was null or undefined when calling openDeliveries().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/deliveries/open`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OpenDeliveriesRequestToJSON(requestParameters['openDeliveriesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CloseDeliveries200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async openDeliveries(requestParameters: OpenDeliveriesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CloseDeliveries200Response> {
        const response = await this.openDeliveriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
